import React from 'react'
import { Link } from 'react-router-dom'
import {
  Alert,
  Card,
  Heading,
  List,
  Item,
} from 'goustouicomponents/dist'
import {
  Box,
  Heading2,
} from '@gousto-internal/citrus-react'
import { useFetchTopArticles } from '../../hooks/useFetchTopArticles'
import { ContentLoader } from '../ContentLoader'
import css from './TopIssues.module.css'

const TopIssuesContent = () => {
  const { isTopArticlesFetching, topArticles } = useFetchTopArticles()

  if (topArticles?.length) {
    return (
      <List>
        {topArticles.map((article) => (
          <List.Item key={article.id}>
            <div
              data-tracking-action="kb_click_top_article"
              data-tracking-property={JSON.stringify({ article_id: `${article.id}` })}
            >
              <Link to={article.url}>
                <Item label={article.title} isLinkStyled={false} />
              </Link>
            </div>
          </List.Item>
        ))}
      </List>
    )
  }

  if (isTopArticlesFetching) {
    return <ContentLoader />
  }

  return (
    <div className={css.alertWrapper}>
      <Alert type="danger">
        <Heading type="h3" size="fontStyleM">Something went wrong!</Heading>
        <p>There is an issue fetching the FAQs.</p>
      </Alert>
    </div>
  )
}

const TopIssues = () => (
  <section>
    <Box className={css.heading} paddingBottom={2}>
      <Heading2 size={4}>Frequently asked questions</Heading2>
    </Box>
    <Card
      hasPaddingVertical={false}
      css={{ marginBottom: 0 }}
    >
      <TopIssuesContent />
    </Card>
  </section>
)

export { TopIssues }
